import React from 'react';
import { BaseConfigProps, commonStyles } from '../shared/ConfigFormHelpers';

const OpenAIChatConfig: React.FC<BaseConfigProps> = ({ node, updateConfig }) => {
  return (
    <div className="space-y-4">
      <div>
        <label className={commonStyles.label}>
          API Kulcs
        </label>
        <input
          type="password"
          value={node.data.config?.apiKey || ''}
          onChange={(e) => updateConfig('apiKey', e.target.value)}
          placeholder="sk-..."
          className={commonStyles.input}
        />
      </div>
      
      <div>
        <label className={commonStyles.label}>
          Modell
        </label>
        <select
          value={node.data.config?.model || 'gpt-3.5-turbo'}
          onChange={(e) => updateConfig('model', e.target.value)}
          className={commonStyles.select}
        >
          <option value="gpt-3.5-turbo">GPT-3.5 Turbo</option>
          <option value="gpt-4">GPT-4</option>
          <option value="gpt-4-turbo-preview">GPT-4 Turbo</option>
        </select>
      </div>

      <div>
        <label className={commonStyles.label}>
          Prompt
        </label>
        <textarea
          value={node.data.config?.prompt || ''}
          onChange={(e) => updateConfig('prompt', e.target.value)}
          placeholder="Add meg a kérdést vagy utasítást..."
          rows={4}
          className={commonStyles.textarea}
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className={commonStyles.label}>
            Max Tokenek
          </label>
          <input
            type="number"
            value={node.data.config?.maxTokens || 1000}
            onChange={(e) => updateConfig('maxTokens', parseInt(e.target.value))}
            min="1"
            max="4000"
            className={commonStyles.input}
          />
        </div>
        
        <div>
          <label className={commonStyles.label}>
            Hőmérséklet
          </label>
          <input
            type="number"
            value={node.data.config?.temperature || 0.7}
            onChange={(e) => updateConfig('temperature', parseFloat(e.target.value))}
            min="0"
            max="2"
            step="0.1"
            className={commonStyles.input}
          />
        </div>
      </div>
    </div>
  );
};

export default OpenAIChatConfig;
